import { useEffect, useState } from "react";
import useLoading from "../../../hooks/useLoading";
import ContentLoader from "../ContentLoader";
import { Box, Button, Typography } from "@mui/material";
import OrderTypeWay from "./OrderTypeWay";

interface Props {
  name: string;
  label: string;
  value: any;
  setValue: any;
  register: any;
  resource?: any;
  slug?: any;
}
const InputNestedKeyValue: React.FC<Props> = ({
  name,
  label,
  value,
  setValue,
  register,
  resource,
  slug,
}: Props) => {
  const [state, setState] = useState<any>([]);

  // console.log({ state });

  const handleAddOrderTypeWay = () => {
    setState((prev: any) => [
      ...prev,
      { key: "", value: "", payments: [{ key0: "", value0: "" }], type: "" },
    ]);
  };

  useEffect(() => {
    register(name);
    if (value)
      setState([
        ...value.map((orderWay: any) => ({
          key: orderWay.name,
          value: orderWay.simphonyID,
          priceSequence: orderWay.priceSequence,
          payments: orderWay.orderTypeWayPayment.map(
            (pay: any, index: number) => ({
              [`key${index}`]: pay.name,
              [`value${index}`]: pay.simphonyID,
            })
          ),
        })),
      ]);
  }, []);

  useEffect(() => {
    setValue(name, state);
  }, [state]);

  //   console.log({ state });

  const handleUpdateOrderTypeWay = (
    index: number,
    updatedOrderTypeWay: any
  ) => {
    // console.log({ updatedOrderTypeWay });
    setState((prev: any) =>
      prev.map((item: any, i: number) =>
        i === index ? updatedOrderTypeWay : item
      )
    );
  };

  // console.log({ state , value });

  return (
    <Box>
      <Typography variant="h4">Tender Configuration</Typography>
      <Typography variant="caption">delivery = 1 - takeaway = 2 *</Typography>
      {state.map((item: any, index: number) => (
        <Box paddingY={1} key={index}>
          <OrderTypeWay
            index={index}
            data={item}
            onUpdate={(updatedOrder: any) =>
              handleUpdateOrderTypeWay(index, updatedOrder)
            }
          />
        </Box>
      ))}

      <Button
        variant="outlined"
        sx={{ marginY: 1 }}
        onClick={handleAddOrderTypeWay}
      >
        Add Order Type Way
      </Button>
    </Box>
  );
};

export default InputNestedKeyValue;
